import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Auth0Service } from 'src/app/auth/auth0.service';
import { StorageService } from '../services/storage.service';
import { StorageType } from '../models/constants';

/** Opt-in for a caller that branches on the HTTP status: its errors pass through as the
 *  HttpErrorResponse instead of being flattened to a message. */
export const RAW_HTTP_ERROR = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authenticationService: Auth0Service,
    private storageService: StorageService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if ([401].indexOf(err.status) !== -1) {
          // Only end the session if we actually hold a token — a 401 on an
          // already-logged-out request must not trigger another logout, and
          // its navigation would abort an in-flight Auth0 logout redirect,
          // leaving the SSO session alive (MDG-37).
          if (this.storageService.get(StorageType.auth0Token)) {
            this.authenticationService.logout();
            this.router.navigate(['/']);
          }
        }

        if (request.context.get(RAW_HTTP_ERROR)) {
          return throwError(err);
        }

        if (err.error?.data && this.hasValues(err.error.data)) {
          return throwError(err.error);
        }

        const error = err.error.error || err.error.message || err.statusText;
        return throwError(error);
      }),
    );
  }

  hasValues(obj) {
    return Object.values(obj).some(v => v !== null && typeof v !== 'undefined');
  }
}
